import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class CacheService {

	clearCache$ = new Subject<boolean>();

	constructor() { }

	clear(): void {
		this.clearCache$.next(true)
	}

}
